module.exports = __webpack_public_path__ + "img/0x6aB6d61428fde76768D7b45D8BFeec19c6eF91A8.c797395e.png";